import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MountainLake1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_LAKE1;
}

export default MountainLake1PoiTileEntity;
